import React from 'react';
import radium from 'radium';
import { ThemeContext } from '../theme/Theme.jsx';

function Section(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		margin: context.themeManager
			.value('section', 'margin-top-mobile', 'section-margin-mobile'),
		backgroundColor: context.themeManager
			.value('section', 'background', 'bg-color-section'),
		'@media(min-width : 768px)': {
			padding: '0 3em 0em',
			margin: context.themeManager
				.value('section', 'margin-top-mobile', 'section-margin-desktop'),
		},
	};

	const errStyle = {
		padding: '0.5em 0 0',
		border: '2px solid #e10101',
		'@media(min-width : 768px)': {
			padding: '0.5em 3em 0em',
		},
	};

	return (
		<div className="section" style={[style, props.style, props.error ? errStyle : null]} >
			{props.children}
		</div>
	);
}

export default radium(Section);
